import 'regenerator-runtime/runtime';

// ↓ 加载监控插件
// 收到提示： page spy 就测试服需要 其他的可以关了 --收到此消息于 2025.03.24 19:44:54 星期一
export function fnToLoadPageSpy() {
    if (location.origin.startsWith('http://localhost:')) {
        return; // 开发环境不启用，
    }
    const toInitPageSpy = async () => {
        if (!PageSpy) {
            return console.log('toInitPageSpy() aborted');
        }
        await window.scheduler.yield();
        PageSpy.registerPlugin(new DataHarborPlugin());
        await window.scheduler.yield();
        PageSpy.registerPlugin(new RRWebPlugin());
        await window.scheduler.yield();
        const newIt = async () => {
            console.log('new PageSpy() begin', new Date().toISOString());
            window.$pageSpy = new PageSpy({
                project: 'BetCorgi-mini',
                autoRender: true,
                title: 'BetCorgi',
                serializeData: true,
            });
            console.log('new PageSpy() done', new Date().toISOString());
        };
        /* ↓ 必要情况下临时改为 if(1) 启动紧急加载模式  */
        if (0) {
            newIt();
        } else if ('scheduler' in window && 'postTask' in window.scheduler) {
            window.scheduler.postTask(newIt, {
                priority: 'background',
            });
        } else if ('requestIdleCallback' in window) {
            requestIdleCallback(newIt);
        } else {
            setTimeout(newIt);
        }
    };
    const usePageSpy = async () => {
        console.log('usePageSpy started:', new Date().toISOString());
        await window.scheduler.yield();
        const jsList = [
            Object.assign(document.createElement('script'), {
                src: 'http://13.251.74.122:6752/page-spy/index.min.js',
                crossorigin: 'anonymous',
                async: true,
            }),
            Object.assign(document.createElement('script'), {
                src: 'http://13.251.74.122:6752/plugin/data-harbor/index.min.js',
                crossorigin: 'anonymous',
                async: true,
            }),
            Object.assign(document.createElement('script'), {
                src: 'http://13.251.74.122:6752/plugin/rrweb/index.min.js',
                crossorigin: 'anonymous',
                async: true,
            }),
        ];
        for (const [idx, cur] of jsList.entries()) {
            let resolve = (xx) => {};
            let reject = () => {};
            const promise = new Promise((f1, f2) => {
                resolve = f1;
                reject = f2;
            });
            cur.onload = () => resolve(true);
            cur.onerror = reject;
            document.head.appendChild(cur);
            const isLoaded = await promise.catch((err) => {
                console.log('PageSpy file loading failed', idx, cur.src);
            });
            if (!isLoaded) return;
            console.log('PageSpy file loaded:', idx, new Date().toISOString());
        }
        toInitPageSpy();
    };
    console.log('fnToLoadPageSpy', document.readyState);
    if (document.readyState === 'complete') {
        // 页面已经加载完成，直接执行
        usePageSpy();
    } else {
        // 页面未加载完成，监听 load 事件
        window.addEventListener('load', usePageSpy);
    }
}
